module.exports = __webpack_public_path__ + "static/media/03_BaerbelWagner_webfinal.17d6c358.jpg";